import { useContext, useEffect, useRef, useState } from "react";
import SuccessToast from "../toasts/SuccessToast";
import MqttManager from "../../mqtt/Base";
import { DevicesList } from "../../api/api";
import Devices from "../../constants/Devices";
import ForeignScenario from "../../constants/ForeignScenario";
import BussScenarioLearnCodeModal from "./BussScenarioLearnCodeModal";
import { MqttContext } from "../../context/MQTTContext";
import { Context } from "../../context/Context";

const BussScenarioModal = ({
  setBussScenarioModal,
  inputNum,
  setInputNum,
  selectedDevice,
  setSelectedDevice,
  scenario,
}) => {
  const { setIsLoading, scenarioCommands, setScenarioCommands, devices } =
    useContext(Context);
  const { clients } = useContext(MqttContext);

  // const [devices, setDevices] = useState([]);
  const [devicesList, setDevicesList] = useState([]);
  const [inputType, setInputType] = useState(null);
  const [bussScenarioLearnCodeModal, setBussScenarioLearnCodeModal] =
    useState();
  const modalName = useRef(null);
  const closeButton = useRef(null);

  const activeListeners = useRef({});

  useEffect(() => {
    const cleanupListeners = () => {
      Object.keys(activeListeners.current).forEach((deviceId) => {
        const listenerInfo = activeListeners.current[deviceId];
        if (listenerInfo && listenerInfo.client) {
          listenerInfo.client.off("message", listenerInfo.listener);
        }
      });
      activeListeners.current = {};
    };
    return cleanupListeners;
  }, []);

  useEffect(() => {
    setBussScenarioModal(modalName);
    const filteredDevices = devices.filter((d) => d.fw_version >= 15);
    setDevicesList(filteredDevices);
    setSelectedDevice(filteredDevices[0]);
  }, [devices]);

  useEffect(() => {
    if (selectedDevice) {
      const foreignDevice = ForeignScenario.find(
        (f) => f.device_type == selectedDevice.type,
      );

      if (foreignDevice && foreignDevice.scenario_type) {
        // Set the initial input type if the first key exists
        const firstKey = Object.keys(foreignDevice.scenario_type)[0];
        setInputType({ 0: foreignDevice.scenario_type[firstKey] });
      }
    }
  }, [selectedDevice]);

  useEffect(() => {
    if (selectedDevice && inputType) {
      const foreignDevice = ForeignScenario.find(
        (f) => f.device_type == selectedDevice.type,
      );

      if (foreignDevice) {
        // Set the initial input type if the first key exists
        const first = foreignDevice.scenario_num[Object.keys(inputType)[0]][0];
        setInputNum(first.value);
      }
    }
  }, [selectedDevice, inputType]);

  const concatenateStringAndBuffer = (str, buffer) => {
    let encoder = new TextEncoder();
    let encodedString = encoder.encode(str); // تبدیل رشته به بایت‌ها

    // ساخت یک بافر جدید که به اندازه رشته و بافر اصلی است
    let newBuffer = new Uint8Array(encodedString.length + buffer.byteLength);

    // قرار دادن رشته در ابتدا
    newBuffer.set(encodedString, 0);

    // قرار دادن بافر در ادامه
    newBuffer.set(new Uint8Array(buffer), encodedString.length);

    return newBuffer;
  };

  const handleBussScenarioLearnCodeModal = () => {
    const modal = new window.bootstrap.Modal(
      bussScenarioLearnCodeModal.current,
    );
    modal.show();
  };

  const handleChangeDevice = (e) => {
    const dev = devices.find((d) => d.serial == e.target.value);
    if (!dev) {
      return;
    }
    const foreignDevice = ForeignScenario.find(
      (f) => f.device_type == selectedDevice.type,
    );

    if (foreignDevice && foreignDevice.scenario_type) {
      // Set the initial input type if the first key exists
      const firstKey = Object.keys(foreignDevice.scenario_type)[0];
      setInputType({ 0: foreignDevice.scenario_type[firstKey] });
    }
    setSelectedDevice(dev);
  };

  const handleChangeInputType = (e) => {
    const foreignDevice = ForeignScenario.find(
      (f) => f.device_type == selectedDevice.type,
    );
    if (foreignDevice) {
      setInputType({
        [e.target.value]: foreignDevice.scenario_type[e.target.value],
      });
    }
  };

  const handleChangeInputNum = (e) => {
    setInputNum(e.target.value);
  };

  const renderInputType = () => {
    if (!selectedDevice) return 0;
    const foreignDevice = ForeignScenario.find(
      (f) => f.device_type == selectedDevice.type,
    );

    if (!foreignDevice || !foreignDevice.scenario_type) return null;

    return Object.keys(foreignDevice.scenario_type).map((key) => (
      <option key={key} value={key ?? ""}>
        {foreignDevice.scenario_type[key]}
      </option>
    ));
  };

  const renderInputNum = () => {
    if (!selectedDevice || !inputType) return 0;

    const foreignDevice = ForeignScenario.find(
      (f) => f.device_type == selectedDevice.type,
    );
    if (!foreignDevice || !foreignDevice.scenario_type) return null;

    return Object.keys(
      foreignDevice.scenario_num[Object.keys(inputType)[0]],
    ).map((key) => {
      return (
        <option
          key={key}
          value={
            foreignDevice.scenario_num?.[Object.keys(inputType)[0]]?.[key]
              ?.value ?? ""
          }
        >
          {foreignDevice.scenario_num?.[Object.keys(inputType)[0]]?.[key]?.name}
        </option>
      );
    });
  };

  const calculate_time_code = (time) => {
    if (time >= 0 && time <= 20000) {
      return time / 500;
    } else if (time >= 21000 && time <= 59000) {
      return time / 1000 + 20;
    } else if (time == 60000) {
      return 80;
    } else if (time == 120000) {
      return 81;
    } else if (time == 180000) {
      return 82;
    } else if (time == 240000) {
      return 83;
    } else if (time == 300000) {
      return 84;
    } else if (time == 600000) {
      return 89;
    } else if (time == 900000) {
      return 94;
    } else if (time == 1200000) {
      return 99;
    } else if (time == 1800000) {
      return 109;
    } else if (time == 2400000) {
      return 119;
    } else if (time == 3000000) {
      return 129;
    } else if (time == 3600000) {
      return 139;
    }
  };

  const handleSubmit = () => {
    let commands = scenarioCommands.filter(
      (cmd) => cmd.scenario_id == scenario.id,
    );
    if (!commands.length) return;

    let total_time = 0;
    for (let i = 0; i < commands.length; i++) {
      total_time += commands[i].time;
    }

    const orderedDeviceIds = [];
    const groupedByDeviceId = commands.reduce((acc, item) => {
      const { device_id } = item;

      if (!acc[device_id]) {
        acc[device_id] = [];
        orderedDeviceIds.push(device_id);
      }

      acc[device_id].push(item);
      return acc;
    }, {});

    let devices_count = {};
    orderedDeviceIds.forEach((deviceId, index) => {
      // اگر این دستگاه اولین دستگاه باشد
      if (index == 0) {
        devices_count[deviceId] = groupedByDeviceId[deviceId].length;
      } else {
        devices_count[deviceId] = groupedByDeviceId[deviceId].length + 1; // یک به مقدار اضافه می‌کنیم
      }
    });

    let devicesCommands = {};

    let calc_time = 0;
    commands.forEach((command) => {
      let device = devices.find((d) => d.id == command.device_id);
      if (!device) {
        return;
      }
      if (!devicesCommands.hasOwnProperty(command.device_id)) {
        devicesCommands[command.device_id] = [
          device.serial[0].charCodeAt(0),
          device.serial[1].charCodeAt(0),
          device.serial[2].charCodeAt(0),
          device.serial[3].charCodeAt(0),
          device.serial[4].charCodeAt(0),
          device.serial[5].charCodeAt(0),
          device.is_bus == 1 ? device.type + 50 : device.type,
          devices_count[command.device_id],
        ];
        if (command.device_id != commands[0].device_id) {
          if (
            device.type == 1 ||
            device.type == 2 ||
            device.type == 7 ||
            device.type == 8 ||
            device.type == 10 ||
            device.type == 11 ||
            device.type == 12 ||
            device.type == 13 ||
            device.type == 14 ||
            device.type == 15
          ) {
            devicesCommands[command.device_id] = [
              ...devicesCommands[command.device_id],
              0,
              0,
              (calc_time & 0xff00) >> 8,
              calc_time & 0xff,
            ];
          }
          if (device.type == 5) {
            devicesCommands[command.device_id] = [
              ...devicesCommands[command.device_id],
              0,
              0,
              0,
              0,
              (calc_time & 0xff00) >> 8,
              calc_time & 0xff,
            ];
          }
          if (device.type == 4 || device.type == 9) {
            devicesCommands[command.device_id] = [
              ...devicesCommands[command.device_id],
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              (calc_time & 0xff00) >> 8,
              calc_time & 0xff,
            ];
          }
          if (device.type == 3) {
            devicesCommands[command.device_id] = [
              ...devicesCommands[command.device_id],
              0,
              (calc_time & 0xff00) >> 8,
              calc_time & 0xff,
            ];
          }
        }
      }

      let time = 0;
      for (const cmd of commands) {
        if (cmd.id >= command.id) {
          if (cmd.device_id == command.device_id && cmd.id != command.id) {
            break; // Exit the loop when the device_id matches
          }
          time += Number(cmd.time); // Accumulate time
        }
      }
      // جمع‌آوری داده‌ها
      devicesCommands[command.device_id] = [
        ...devicesCommands[command.device_id],
        ...(command.data1 != null ? [command.data1] : []),
        ...(command.data2 != null ? [command.data2] : []),
        ...(command.data3 != null ? [command.data3] : []),
        ...(command.data4 != null ? [command.data4] : []),
        ...(command.data5 != null ? [command.data5] : []),
        ...(command.data6 != null ? [command.data6] : []),
        ...(command.data7 != null ? [command.data7] : []),
        ...(command.data8 != null ? [command.data8] : []),
        ...(command.data9 != null ? [command.data9] : []),
        ...(command.data10 != null ? [command.data10] : []),
        ...(command.data11 != null ? [command.data11] : []),
        ((time / 500) & 0xff00) >> 8,
        (time / 500) & 0xff,
        ...(groupedByDeviceId[command.device_id][
          groupedByDeviceId[command.device_id].length - 1
        ].id == command.id
          ? [scenario.repeat]
          : []),
      ];

      calc_time += Number(command.time) / 500;
    });

    const data = Object.keys(devicesCommands).flatMap(
      (key) => devicesCommands[key],
    );
    data.unshift(Object.keys(devices_count).length);
    data.unshift(Number(inputNum));
    data.unshift(13);
    if (selectedDevice.is_bus == 1) {
      if (!clients[selectedDevice.bridge_device.id]) return;

      const client = clients[selectedDevice.bridge_device.id]; // استفاده از bridge_client

      // حذف listener قبلی
      if (client._assignBussScenarioListener) {
        client.off("message", client._assignBussScenarioListener);
        client._assignBussScenarioListener = null;
      }

      const messageListener = (topic, message, packet) => {
        const endOfTwoCharToken =
          String.fromCharCode(message[0]) + String.fromCharCode(message[1]);
        const deviceSerial =
          String.fromCharCode(message[3]) +
          String.fromCharCode(message[4]) +
          String.fromCharCode(message[5]) +
          String.fromCharCode(message[6]) +
          String.fromCharCode(message[7]) +
          String.fromCharCode(message[8]);

        if (
          selectedDevice.bridge_device.internet_token.slice(-2) ==
            endOfTwoCharToken &&
          selectedDevice.serial == deviceSerial &&
          message[10] == 13 &&
          message[2] == 14
        ) {
          SuccessToast(
            "به" +
              " " +
              inputType[Object.keys(inputType)[0]] +
              " " +
              message[11] +
              " " +
              "اختصاص یافت",
          );
          client.off("message", messageListener);
          if (activeListeners.current[selectedDevice.bridge_device.id]) {
            // استفاده از bridge_device.id
            delete activeListeners.current[selectedDevice.bridge_device.id];
          }
          client._assignBussScenarioListener = null;
          closeButton.current.click();
        }
      };

      // حذف listener قبلی از activeListeners
      if (activeListeners.current[selectedDevice.bridge_device.id]) {
        client.off(
          "message",
          activeListeners.current[selectedDevice.bridge_device.id].listener,
        );
      }

      // ذخیره listener جدید با کلید bridge_device.id
      activeListeners.current[selectedDevice.bridge_device.id] = {
        client: client,
        listener: messageListener,
      };

      client._assignBussScenarioListener = messageListener;
      client.on("message", messageListener); // استفاده از client صحیح

      // ساخت و ارسال پیام
      let buffer = new ArrayBuffer(data.length + 8);
      let asciiCode = new Uint8Array(buffer);
      asciiCode[0] = 14;
      asciiCode[1] = `${selectedDevice.serial[0]}`.charCodeAt(0);
      asciiCode[2] = `${selectedDevice.serial[1]}`.charCodeAt(0);
      asciiCode[3] = `${selectedDevice.serial[2]}`.charCodeAt(0);
      asciiCode[4] = `${selectedDevice.serial[3]}`.charCodeAt(0);
      asciiCode[5] = `${selectedDevice.serial[4]}`.charCodeAt(0);
      asciiCode[6] = `${selectedDevice.serial[5]}`.charCodeAt(0);
      asciiCode[7] = selectedDevice.type + 50;

      for (let i = 0; i <= data.length; i++) {
        asciiCode[i + 8] = data[i];
      }

      let message = selectedDevice.bridge_device.internet_token;
      let combinedMessage = concatenateStringAndBuffer(message, asciiCode);

      // publish با client صحیح (bridge_client)
      client.publish(
        selectedDevice.bridge_device.serial + "/sys",
        combinedMessage,
      );
    } else {
      if (!clients[selectedDevice.id]) return;
      if (selectedDevice.type != 3) {
        const client = clients[selectedDevice.id];
        // remove previous listener if exists
        if (client._assignBussScenarioListener) {
          client.off("message", client._assignBussScenarioListener);
          client._assignBussScenarioListener = null;
        }
        const messageListener = (topic, message, packet) => {
          const endOfTwoCharToken =
            String.fromCharCode(message[0]) + String.fromCharCode(message[1]);
          if (
            selectedDevice.internet_token.slice(-2) == endOfTwoCharToken &&
            message[2] == 13
          ) {
            SuccessToast(
              "به" +
                " " +
                inputType[Object.keys(inputType)[0]] +
                " " +
                message[3] +
                " " +
                "اختصاص یافت",
            );
            client.off("message", messageListener);
            if (activeListeners.current[selectedDevice.id]) {
              delete activeListeners.current[selectedDevice.id];
            }
            client._assignBussScenarioListener = null;
            closeButton.current.click();
          }
        };
        if (activeListeners.current[selectedDevice.id]) {
          client.off(
            "message",
            activeListeners.current[selectedDevice.id].listener,
          );
        }

        activeListeners.current[selectedDevice.id] = {
          client: client,
          listener: messageListener,
        };

        client._assignBussScenarioListener = messageListener;
        clients[selectedDevice.id].on("message", messageListener);
      }

      let buffer = new ArrayBuffer(data.length);
      let asciiCode = new Uint8Array(buffer);
      for (let i = 0; i <= data.length; i++) {
        asciiCode[i] = data[i];
      }
      let message = selectedDevice.internet_token;
      let combinedMessage = concatenateStringAndBuffer(message, asciiCode);
      console.log("combinedMessage is", combinedMessage);
      clients[selectedDevice.id].publish(
        selectedDevice.serial + "/sys",
        combinedMessage,
      );
    }

    if (selectedDevice.type == 3) {
      handleBussScenarioLearnCodeModal();
      closeButton.current.click();
    }
  };

  return (
    <>
      <div
        className="modal fade"
        id="learnCodeModal"
        tabIndex="-1"
        aria-labelledby="learnCodeLabel"
        aria-hidden="true"
        ref={modalName}
      >
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title" id="learnCodeLabel">
                انتخاب ورودی
              </h5>
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
                ref={closeButton}
              ></button>
            </div>
            <div className="modal-body">
              <div className="row">
                <div className="col-12">
                  <div className="mb-3">
                    <label htmlFor="devices" className="form-label">
                      دستگاه
                    </label>
                    <select
                      defaultValue={devicesList[0]?.serial}
                      onChange={(e) => handleChangeDevice(e)}
                      id="devices"
                      className="form-select"
                    >
                      {devicesList.map((device, index) => {
                        let dev = Devices.find((d) => d.type == device.type);
                        return (
                          <option value={device.serial ?? ""} key={index}>
                            {dev.prefix} - {device.serial} {device.name}
                          </option>
                        );
                      })}
                    </select>
                  </div>
                </div>
                <div className="col-6">
                  <div className="mb-3">
                    <select
                      id="inputType"
                      className="form-select"
                      value={inputType ? Object.keys(inputType)[0] : null}
                      onChange={(e) => handleChangeInputType(e)}
                    >
                      {renderInputType()}
                    </select>
                  </div>
                </div>
                <div className="col-6">
                  <div className="mb-3">
                    <select
                      id="inputNum"
                      className="form-select"
                      value={inputNum}
                      onChange={(e) => handleChangeInputNum(e)}
                    >
                      {renderInputNum()}
                    </select>
                  </div>
                </div>
              </div>
            </div>
            <div className="modal-footer">
              <button
                type="button"
                className="btn btn-success-app mb-2"
                onClick={handleSubmit}
              >
                تایید
              </button>
              {/* <button
                type="button"
                className="btn btn-outline-success-app mb-2"
                data-bs-dismiss="modal"
                aria-label="Close"
              >
                انصراف
              </button> */}
            </div>
          </div>
        </div>
      </div>
      <BussScenarioLearnCodeModal
        setBussScenarioLearnCodeModal={setBussScenarioLearnCodeModal}
        device={selectedDevice}
      />
    </>
  );
};

export default BussScenarioModal;
